import { render, staticRenderFns } from "./replies.vue?vue&type=template&id=e7134606&scoped=true&"
import script from "./replies.vue?vue&type=script&lang=js&"
export * from "./replies.vue?vue&type=script&lang=js&"
import style0 from "./replies.vue?vue&type=style&index=0&id=e7134606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7134606",
  null
  
)

export default component.exports